import { Component, OnInit, Inject } from "@angular/core";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material";
import { ServerService } from "src/app/services/server.service";
import { ClipBoardService as messageService } from "src/app/services/clipboard.service";

@Component({
  selector: 'app-presales-done-status',
  templateUrl: './presales-done-status.component.html',
  styleUrls: ['./presales-done-status.component.scss']
})
export class PresalesDoneStatusComponent implements OnInit {

  createPresalesJob: FormGroup;
  presales_calling_reason_list: any;
  presales_calling_type_list: any;
  priority_list: any;
  presales_target_type_list: any;
  presalesFiles: any = [];
  file: File = null;
  authToken = localStorage.getItem("token");
  btnStatus = false;
  preSalesId:any
  constructor(
    private dialogRef: MatDialogRef<PresalesDoneStatusComponent>,
    private fb: FormBuilder,
    private clipBoardMessageService: messageService,
    private _serverService: ServerService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {

    this.getCommonDetails();
    // console.log(this.data)
    this.preSalesId = this.data.id
  }
 
  close() {
    this.dialogRef.close();
  }
  createPreSalesJob() {
    // debugger
    this.btnStatus = true;
    const formData: FormData = new FormData();

    // console.log(this.formatDateTime(this.createPresalesJob.value.completed_at));
    // formData.append("target_type", this.createPresalesJob.value.target_type);
    // formData.append("sourced_leads", this.createPresalesJob.value.source_leads);
    // formData.append("pitch", this.file, this.file.name);
    // formData.append("campaign_id", this.data);
    formData.append("status", "Done");
    formData.append('campaign_id',this.data.campaign_id)
    let url= 'campaign_module/pre_sales_jobs/'+this.data.id;
    this._serverService
      .updateEscalationJobDetails(url, formData, this.authToken)
      .subscribe((data) => {
        this.clipBoardMessageService.showMessgeInText(
          "Pre Sales Job Status Marked as Done Successfully",
          "success-snackbar"
        );
        this.dialogRef.close(data);
      },
      error => {
       console.error('Changing of Pre Sales Job Status failed', error);
       this.btnStatus = false;
       // this.showComponentLoader = false;
     });
  }
  fileChanged(event: any) {
    this.file = event.target.files[0];
  }
  getCommonDetails() {
    this._serverService.getAllStatus(this.authToken).subscribe((data: any) => {
      this.presales_calling_reason_list = data.presales_calling_reason_list;
      this.presales_calling_type_list = data.presales_calling_type_list;
      this.priority_list = data.priority_list;
      this.presales_target_type_list = data.presales_target_type_list;
    });
  }
  remove() {
    this.file = null;
  }
  formatDateTime(input: string): string {
    // Split the date and time parts
    const [datePart, timePart] = input.split('T');

    // Add seconds part to the time
    const formattedTimePart = `${timePart}:00`;

    // Combine the date and new time parts
    return `${datePart} ${formattedTimePart}`;
}

// const input = '2024-07-29T13:07';
// const formattedOutput = formatDateTime(input);
// console.log(formattedOutput); 
}
